module.exports = __webpack_public_path__ + "img/web_ncyu_2.da334d3c.jpg";